import { IconCircleCheck } from '@tabler/icons-react'
import styled from 'styled-components'

import { omitProps } from '@subaio/components'

import { helpers } from '../../../../styles/theme'

type Props = {
	isChecked: boolean
}

export const CheckMark = styled(IconCircleCheck).withConfig({ shouldForwardProp: omitProps('isChecked') })<Props>`
	opacity: ${({ isChecked }) => (isChecked ? 1 : 0)};
	color: ${helpers.color.input.menuOptionCheckMark};
	transition: opacity 135ms ease;
	flex-shrink: 0;
`
